import type { ApiError } from "./api";
import type { AuthStringKey } from "./strings";

/** The message for errors that every screen shows the same way. */
export function commonErrorKey(error: ApiError): AuthStringKey {
  switch (error.kind) {
    case "offline":
      return "common.offline";
    case "rate_limited":
      return "common.rateLimited";
    case "http":
      return "common.error";
  }
}

/** The parent session is missing or too old for a sensitive action (ADR-0018). */
export function needsFreshSignIn(error: ApiError): boolean {
  return (
    error.kind === "http" &&
    (error.status === 401 || (error.status === 403 && error.code === "reauth_required"))
  );
}
